'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var log = Object.assign(debug('libp2p:peer-store:proto-book'), {
  error: debug('libp2p:peer-store:proto-book:err')
});

var errcode = require('err-code');

var PeerId = require('peer-id');

var Book = require('./book');

var _require = require('../errors'),
    ERR_INVALID_PARAMETERS = _require.codes.ERR_INVALID_PARAMETERS;
/**
 * @typedef {import('./')} PeerStore
 */

/**
 * @extends {Book}
 *
 * @fires ProtoBook#change:protocols
 */


var ProtoBook = /*#__PURE__*/function (_Book) {
  _inherits(ProtoBook, _Book);

  var _super = _createSuper(ProtoBook);

  /**
   * The ProtoBook is responsible for keeping the known supported
   * protocols of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */
  function ProtoBook(peerStore) {
    var _this;

    _classCallCheck(this, ProtoBook);

    /**
     * PeerStore Event emitter, used by the ProtoBook to emit:
     * "change:protocols" - emitted when the known protocols of a peer change.
     */
    _this = _super.call(this, {
      peerStore: peerStore,
      eventName: 'change:protocols',
      eventProperty: 'protocols',
      eventTransformer: function eventTransformer(data) {
        return Array.from(data);
      }
    });
    /**
     * Map known peers to their known protocols.
     *
     * @type {Map<string, Set<string>>}
     */

    _this.data = new Map();
    return _this;
  }
  /**
   * Set known protocols of a provided peer.
   * If the peer was not known before, it will be added.
   *
   * @override
   * @param {PeerId} peerId
   * @param {string[]} protocols
   * @returns {ProtoBook}
   */


  _createClass(ProtoBook, [{
    key: "set",
    value: function set(peerId, protocols) {
      if (!PeerId.isPeerId(peerId)) {
        log.error('peerId must be an instance of peer-id to store data');
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (!protocols) {
        log.error('protocols must be provided to store data');
        throw errcode(new Error('protocols must be provided'), ERR_INVALID_PARAMETERS);
      }

      var id = peerId.toB58String();
      var recSet = this.data.get(id);
      var newSet = new Set(protocols);
      /**
       * @param {Set<string>} a
       * @param {Set<string>} b
       */

      var isSetEqual = function isSetEqual(a, b) {
        return a.size === b.size && _toConsumableArray(a).every(function (value) {
          return b.has(value);
        });
      }; // Already knows the peer and the recorded protocols are the same?
      // If yes, no changes needed!


      if (recSet && isSetEqual(recSet, newSet)) {
        log("the protocols provided to store are equal to the already stored for ".concat(id));
        return this;
      }

      this._setData(peerId, newSet);

      log("stored provided protocols for ".concat(id));
      return this;
    }
    /**
     * Adds known protocols of a provided peer.
     * If the peer was not known before, it will be added.
     *
     * @param {PeerId} peerId
     * @param {string[]} protocols
     * @returns {ProtoBook}
     */

  }, {
    key: "add",
    value: function add(peerId, protocols) {
      if (!PeerId.isPeerId(peerId)) {
        log.error('peerId must be an instance of peer-id to store data');
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (!protocols) {
        log.error('protocols must be provided to store data');
        throw errcode(new Error('protocols must be provided'), ERR_INVALID_PARAMETERS);
      }

      var id = peerId.toB58String();
      var recSet = this.data.get(id) || new Set();
      var newSet = new Set([].concat(_toConsumableArray(recSet), _toConsumableArray(protocols))); // Set Union
      // Any new protocol added?

      if (recSet.size === newSet.size) {
        log("the protocols provided to store are already stored for ".concat(id));
        return this;
      }

      this._setData(peerId, newSet);

      log("added provided protocols for ".concat(id));
      return this;
    }
    /**
     * Removes known protocols of a provided peer.
     * If the protocols did not exist before, nothing will be done.
     *
     * @param {PeerId} peerId
     * @param {string[]} protocols
     * @returns {ProtoBook}
     */

  }, {
    key: "remove",
    value: function remove(peerId, protocols) {
      if (!PeerId.isPeerId(peerId)) {
        log.error('peerId must be an instance of peer-id to store data');
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (!protocols) {
        log.error('protocols must be provided to store data');
        throw errcode(new Error('protocols must be provided'), ERR_INVALID_PARAMETERS);
      }

      var id = peerId.toB58String();
      var recSet = this.data.get(id);

      if (recSet) {
        var newSet = new Set(_toConsumableArray(recSet).filter(function (p) {
          return !protocols.includes(p);
        })); // Any protocol removed?

        if (recSet.size === newSet.size) {
          return this;
        }

        this._setData(peerId, newSet);

        log("removed provided protocols for ".concat(id));
      }

      return this;
    }
  }]);

  return ProtoBook;
}(Book);

module.exports = ProtoBook;